import { useSelector } from 'react-redux';
import { usePageLoader } from '../../../context/pageLoader';
import useIonicToast from '../../../hooks/useIonicToast';
import createWallet from '../walletCreation/createWallet';
import { RootState } from '../../../store/store';

export default function useWalletCreation() {
  const { signedAccessToken: authToken } = useSelector(
    (state: RootState) => state.userSession
  );
  const { setBusy } = usePageLoader();
  const { presentIonToast } = useIonicToast();

  const requestNewWallet = async (customer_id: number) => {
    if (!customer_id || !authToken) return;

    try {
      setBusy(true);
      const res = await createWallet({ customer_id, authToken });
      if (res.success) presentIonToast('Wallet successfully created.');
      else {
        presentIonToast(
          'We are unable to create your wallet, try again.',
          'error'
        );
      }
    } catch (error: any) {
      if (error.status == 404) {
        return presentIonToast(
          'Please complete your wallet kyc before creating a wallet.',
          'error'
        );
      }
      presentIonToast(error.message, 'error');
    } finally {
      setBusy(false);
    }
  };

  return {
    requestNewWallet,
  };
}
